// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-date-picker {
    display: inline-flex;
    position: relative;
  }
  
  .react-date-picker,
  .react-date-picker *,
  .react-date-picker *:before,
  .react-date-picker *:after {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  
  .react-date-picker--disabled {
    background-color: #f0f0f0;
    color: #6d6d6d;
  }
  
  .react-date-picker__wrapper {
    display: flex;
    flex-grow: 1;
    flex-shrink: 0;
    border: thin solid gray;
  }
  
  .react-date-picker__inputGroup {
    min-width: calc((4px * 3) + 0.54em * 8 + 0.217em * 2);
    flex-grow: 1;
    padding: 0 2px;
    box-sizing: content-box;
  }
  
  .react-date-picker__inputGroup__divider {
    padding: 1px 0;
    white-space: pre;
  }
  
  .react-date-picker__inputGroup__divider,
  .react-date-picker__inputGroup__leadingZero {
    display: inline-block;
    font: inherit;
  }
  
  .react-date-picker__inputGroup__input {
    min-width: 0.54em;
    height: 100%;
    position: relative;
    padding: 0 1px;
    border: 0;
    background: none;
    color: currentColor;
    font: inherit;
    box-sizing: content-box;
    -webkit-appearance: textfield;
    -moz-appearance: textfield;
    appearance: textfield;
  }
  
  .react-date-picker__inputGroup__input::-webkit-outer-spin-button,
  .react-date-picker__inputGroup__input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
  }
  
  .react-date-picker__inputGroup__input:invalid {
    background: rgba(255, 0, 0, 0.1);
  }
  
  .react-date-picker__inputGroup__input--hasLeadingZero {
    margin-left: -0.54em;
    padding-left: calc(1px + 0.54em);
  }
  
  .react-date-picker__button {
    border: 0;
    background: transparent;
    padding: 4px 6px;
  }
  
  .react-date-picker__button:enabled {
    cursor: pointer;
  }
  
  .react-date-picker__button:enabled:hover .react-date-picker__button__icon,
  .react-date-picker__button:enabled:focus .react-date-picker__button__icon {
    stroke: #0078d7;
  }
  
  .react-date-picker__button:disabled .react-date-picker__button__icon {
    stroke: #6d6d6d;
  }
  
  .react-date-picker__button svg {
    display: inherit;
  }
  
  .react-date-picker__calendar {
    width: 350px;
    max-width: 100vw;
    z-index: 1;
  }
  
  .react-date-picker__calendar--closed {
    display: none;
  }
  
  .react-date-picker__calendar .react-calendar {
    border-width: thin;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/details/pages/agenda/DatePicker.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;;;;IAIE,2BAA2B;IAC3B,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,cAAc;IACd,uBAAuB;EACzB;;EAEA;IACE,qDAAqD;IACrD,YAAY;IACZ,cAAc;IACd,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;;IAEE,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,6BAA6B;IAC7B,0BAA0B;IAC1B,qBAAqB;EACvB;;EAEA;;IAEE,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,oBAAoB;IACpB,gCAAgC;EAClC;;EAEA;IACE,SAAS;IACT,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB","sourcesContent":[".react-date-picker {\r\n    display: inline-flex;\r\n    position: relative;\r\n  }\r\n  \r\n  .react-date-picker,\r\n  .react-date-picker *,\r\n  .react-date-picker *:before,\r\n  .react-date-picker *:after {\r\n    -moz-box-sizing: border-box;\r\n    -webkit-box-sizing: border-box;\r\n    box-sizing: border-box;\r\n  }\r\n  \r\n  .react-date-picker--disabled {\r\n    background-color: #f0f0f0;\r\n    color: #6d6d6d;\r\n  }\r\n  \r\n  .react-date-picker__wrapper {\r\n    display: flex;\r\n    flex-grow: 1;\r\n    flex-shrink: 0;\r\n    border: thin solid gray;\r\n  }\r\n  \r\n  .react-date-picker__inputGroup {\r\n    min-width: calc((4px * 3) + 0.54em * 8 + 0.217em * 2);\r\n    flex-grow: 1;\r\n    padding: 0 2px;\r\n    box-sizing: content-box;\r\n  }\r\n  \r\n  .react-date-picker__inputGroup__divider {\r\n    padding: 1px 0;\r\n    white-space: pre;\r\n  }\r\n  \r\n  .react-date-picker__inputGroup__divider,\r\n  .react-date-picker__inputGroup__leadingZero {\r\n    display: inline-block;\r\n    font: inherit;\r\n  }\r\n  \r\n  .react-date-picker__inputGroup__input {\r\n    min-width: 0.54em;\r\n    height: 100%;\r\n    position: relative;\r\n    padding: 0 1px;\r\n    border: 0;\r\n    background: none;\r\n    color: currentColor;\r\n    font: inherit;\r\n    box-sizing: content-box;\r\n    -webkit-appearance: textfield;\r\n    -moz-appearance: textfield;\r\n    appearance: textfield;\r\n  }\r\n  \r\n  .react-date-picker__inputGroup__input::-webkit-outer-spin-button,\r\n  .react-date-picker__inputGroup__input::-webkit-inner-spin-button {\r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    appearance: none;\r\n    margin: 0;\r\n  }\r\n  \r\n  .react-date-picker__inputGroup__input:invalid {\r\n    background: rgba(255, 0, 0, 0.1);\r\n  }\r\n  \r\n  .react-date-picker__inputGroup__input--hasLeadingZero {\r\n    margin-left: -0.54em;\r\n    padding-left: calc(1px + 0.54em);\r\n  }\r\n  \r\n  .react-date-picker__button {\r\n    border: 0;\r\n    background: transparent;\r\n    padding: 4px 6px;\r\n  }\r\n  \r\n  .react-date-picker__button:enabled {\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .react-date-picker__button:enabled:hover .react-date-picker__button__icon,\r\n  .react-date-picker__button:enabled:focus .react-date-picker__button__icon {\r\n    stroke: #0078d7;\r\n  }\r\n  \r\n  .react-date-picker__button:disabled .react-date-picker__button__icon {\r\n    stroke: #6d6d6d;\r\n  }\r\n  \r\n  .react-date-picker__button svg {\r\n    display: inherit;\r\n  }\r\n  \r\n  .react-date-picker__calendar {\r\n    width: 350px;\r\n    max-width: 100vw;\r\n    z-index: 1;\r\n  }\r\n  \r\n  .react-date-picker__calendar--closed {\r\n    display: none;\r\n  }\r\n  \r\n  .react-date-picker__calendar .react-calendar {\r\n    border-width: thin;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
